/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.urls.rpc.ScreenshotRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export const GenericUrlErrorTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.GenericUrlError';
export const GenericUrlErrorDiscriminant = 'GENERIC_URL_ERROR';
export const GenericUrlErrorDiscriminantKey = 'type';
export type GenericUrlError = {
  error: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.GenericUrlError';
} & { type?: 'GENERIC_URL_ERROR' };

export const InvalidFormatTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidFormat';
export const InvalidFormatDiscriminant = 'INVALID_FORMAT';
export const InvalidFormatDiscriminantKey = 'type';
export type InvalidFormat = {
  message: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidFormat';
} & { type?: 'INVALID_FORMAT' };

export const InvalidLengthTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidLength';
export const InvalidLengthDiscriminant = 'INVALID_LENGTH';
export const InvalidLengthDiscriminantKey = 'type';
export type InvalidLength = {
  message: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidLength';
} & { type?: 'INVALID_LENGTH' };

export const InvalidReservationExtensionTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidReservationExtension';
export const InvalidReservationExtensionDiscriminant =
  'INVALID_RESERVATION_EXTENSION';
export const InvalidReservationExtensionDiscriminantKey = 'type';
export type InvalidReservationExtension = {
  currentReservationExpiration: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidReservationExtension';
} & { type?: 'INVALID_RESERVATION_EXTENSION' };

export const MarketplaceUrlsClientErrorDiscriminantKey = 'type';
export type MarketplaceUrlsClientError =
  | SiteNotFound
  | UrlInUse
  | UrlAlreadyRegistered
  | UrlNotFound
  | UrlAlreadyReserved
  | UrlNotReserved
  | InvalidReservationExtension
  | PortalIdMismatch
  | UnexpectedRegex
  | GenericUrlError
  | InvalidLength
  | InvalidFormat
  | ScreenshotNotFound;

export const PortalIdMismatchTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.PortalIdMismatch';
export const PortalIdMismatchDiscriminant = 'PORTAL_ID_MISMATCH';
export const PortalIdMismatchDiscriminantKey = 'type';
export type PortalIdMismatch = {
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.PortalIdMismatch';
} & { type?: 'PORTAL_ID_MISMATCH' };

export const ScreenshotNotFoundTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.ScreenshotNotFound';
export const ScreenshotNotFoundDiscriminant = 'SCREENSHOT_NOT_FOUND';
export const ScreenshotNotFoundDiscriminantKey = 'type';
export type ScreenshotNotFound = {
  siteKey: string;
  path: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.ScreenshotNotFound';
} & { type?: 'SCREENSHOT_NOT_FOUND' };

export const SiteNotFoundTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.SiteNotFound';
export const SiteNotFoundDiscriminant = 'SITE_NOT_FOUND';
export const SiteNotFoundDiscriminantKey = 'type';
export type SiteNotFound = {
  siteKey?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.SiteNotFound';
} & { type?: 'SITE_NOT_FOUND' };

export const UnexpectedRegexTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.UnexpectedRegex';
export const UnexpectedRegexDiscriminant = 'UNEXPECTED_REGEX';
export const UnexpectedRegexDiscriminantKey = 'type';
export type UnexpectedRegex = {
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.UnexpectedRegex';
} & { type?: 'UNEXPECTED_REGEX' };

export const UrlAlreadyRegisteredTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.UrlAlreadyRegistered';
export const UrlAlreadyRegisteredDiscriminant = 'URL_ALREADY_REGISTERED';
export const UrlAlreadyRegisteredDiscriminantKey = 'type';
export type UrlAlreadyRegistered = {
  path: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlAlreadyRegistered';
} & { type?: 'URL_ALREADY_REGISTERED' };

export const UrlAlreadyReservedTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.UrlAlreadyReserved';
export const UrlAlreadyReservedDiscriminant = 'URL_ALREADY_RESERVED';
export const UrlAlreadyReservedDiscriminantKey = 'type';
export type UrlAlreadyReserved = {
  path: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlAlreadyReserved';
} & { type?: 'URL_ALREADY_RESERVED' };

export const UrlInUseTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.UrlInUse';
export const UrlInUseDiscriminant = 'URL_IN_USE';
export const UrlInUseDiscriminantKey = 'type';
export type UrlInUse = {
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlInUse';
} & { type?: 'URL_IN_USE' };

export const UrlNotFoundTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.UrlNotFound';
export const UrlNotFoundDiscriminant = 'URL_NOT_FOUND';
export const UrlNotFoundDiscriminantKey = 'type';
export type UrlNotFound = {
  siteKey: string;
  path: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlNotFound';
} & { type?: 'URL_NOT_FOUND' };

export const UrlNotReservedTypename =
  'com.hubspot.marketplace.urls.models.rpcs.errors.UrlNotReserved';
export const UrlNotReservedDiscriminant = 'URL_NOT_RESERVED';
export const UrlNotReservedDiscriminantKey = 'type';
export type UrlNotReserved = {
  siteKey: string;
  path: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlNotReserved';
} & { type?: 'URL_NOT_RESERVED' };

export type GetScreenshotRequest = {
  siteKey: string;
  path: string;
  language?: string;
};

export type GetScreenshotResponse = { imageUrl: string; language: string };

export type GetScreenshotV2Request = {
  siteKey: string;
  path: string;
  language?: string;
};

export type GetScreenshotV2Response = { imageUrl?: string };

export type GetScreenshotRequestType = Requestify<GetScreenshotRequest>;
export type GetScreenshotResponseType = GetScreenshotResponse;
export type GetScreenshotErrorType = MarketplaceUrlsClientError &
  HubspotMetadata;
export const getScreenshotRpc: ChirpAvroRpcDetails<
  GetScreenshotRequestType,
  GetScreenshotResponseType,
  GetScreenshotErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.urls.rpc.ScreenshotRpc',
  rpcName: 'getScreenshot',
  auth: 'external',
  fingerprint: 'yMEF2-kjD01cmmMEGroNLwTPIEIL4xPp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetScreenshotV2RequestType = Requestify<GetScreenshotV2Request>;
export type GetScreenshotV2ResponseType = GetScreenshotV2Response;
export type GetScreenshotV2ErrorType = MarketplaceUrlsClientError &
  HubspotMetadata;
export const getScreenshotV2Rpc: ChirpAvroRpcDetails<
  GetScreenshotV2RequestType,
  GetScreenshotV2ResponseType,
  GetScreenshotV2ErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.urls.rpc.ScreenshotRpc',
  rpcName: 'getScreenshotV2',
  auth: 'external',
  fingerprint: '2RwE5B36wxd4GrcNyGeHDwTPIEIL4xPp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
